export class ActivityObjective {
    successStatus: string = "unknown";
    completionStatus: string = "unknown";
    scaled: string = "";
    raw: string = "";
    min: string = "";
    max: string = "";
}
